import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Strategy } from 'app/shared/models/strategy';

@Component({
  selector: 'app-card-affiliation-commissions',
  templateUrl: './card-affiliation-commissions.component.html',
  styleUrls: ['./card-affiliation-commissions.component.sass']
})
export class CardAffiliationCommissionsComponent implements OnInit, OnChanges {
  @Input() commissions: any;
  @Input() groups: any;

  items = [];

  constructor() { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    const groups = changes.groups.currentValue;
    const commissions = changes.commissions.currentValue;

    this.mergeValues(groups, commissions);
  }

  private mergeValues(groups, commissions) {
    const items = [];

    groups.forEach((group) => {
      let match;
      const matches = commissions.filter((commission) => {
        return commission.id === group.id;
      });

      if (matches.length) {
        match = matches[0];
      } else {
        match = group;
      }

      items.push({
        name: group.name,
        type: match.type,
        awin_amount: match.amount,
        awin_percentage: match.percentage,
        reward_amount: group.amount,
        reward_percentage: group.percentage
      });
    });

    this.items = items;
  }
}
